<template>
  <div>
    <div class="CertificateAuthorization" id="CertificateAuthorization">
      <!-- <img src="@/assets/channel/leftCertifAut.png" alt="" class="left" @click="leftClick"> -->
      <div class="context">
        <div>
          <img src="@/assets/icon/login/login-bg-top.png" alt="归创通桥" style="width: 120.25px;height: 52px;margin: 24px;">
        </div>
        <div class="rightTop">
          归创通桥医疗科技股份有限公司
        </div>
        <div class="rightTopEnglish">
          Zylox-Tonbridge Medical Technology Co.,Ltd
        </div>
        <div class="line"></div>
        <div class="rightTopCode">
          编号：{{GCTQList.AuthorityCode}}
        </div>
        <div class="rightTopTitle">
          授权证明书
        </div>
        <div class="contextTop1">
          兹授权<span class="fontRed">{{ GCTQList.ProviderName }}</span>（以下简称“授权经销商”）为归创通桥医疗科技股份有限公司
          （以下简称“归创医疗”）的指定经销商，负责在下列经销区域/医院销售归创医疗的产品：
          <p class="contextListText-p">
            {{ GCTQList.ListInvName.join('、') }}
          </p>
          归创医疗对授权经销商依照其经销合同销售的上述产品提供产品质量保证，承诺对授权经销商在以下地区
          所售出的上述产品提供售后服务和技术支持。
        </div>
        <div class="contextTop2">
          <div>
            经销区域或医院：
          </div>
          <div class="hospital">
            {{  GCTQList.ListHPName.join('、') }}
          </div>
        </div>
        <div class="contextTop3">
          本授权证明书的有效期为<span class="fontRed"> {{ GCTQList.StartDate == null ? '' : GCTQList.StartDate.substring(0,10) }}
          </span>至<span class="fontRed"> {{ GCTQList.EndDate == null ? '' : GCTQList.EndDate.substring(0,10) }} </span>，自本授权证明书生效之日起任何针
          对上述区域、产品做出的原授权证明书立即自动终止。本公司同时保留在本授权证明书有效期内对授权经销商的
          经销区域、产品做出调整的权利。
        </div>
        <div class="contextTop4">
          特此证明！
        </div>
        <div class="contextTop5">
          (对于非由归创医疗授权经销商经销的产品，其产品质量保证、售后服务和技术支持与归创医疗无关，归创
          医疗概不负责提供产品质量保证、售后服务和技术支持。授权经销商应完全具有上述授权医疗器械产品的国家要
          求所必备的各种有效的资质证照，同时保证其经营活动符合相关法律法规且无违反任何执照、批准、资质或备案
          的限制，否则本授权证明书自动失效。）
        </div>
        <div class="contextTop6">
          归创通桥医疗科技股份有限公司
        </div>
        <div class="contextTop7">
          {{ GCTQList.VerifyTime == null ? '' : GCTQList.VerifyTime.substring(0,10) }}
        </div>
        <div class="contextTop8">
          <div class="Top">
            Building No. , 18 Keji Avenue, Wenyixi Road, Future Science & Technology City, Hangzhou, 311121, China
          </div>
          <div class="Centers">
            杭州市文一西路未来科技城科技大道18号1幢
          </div>
          <div class="Bottom">
            TEL：(+86) 571 8861 0082 FAX：(+86) 571 8861 0608 website:www.zyloxmedical.com
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="download">
        <Btn btnType="btn" backgroundColor="#FFFFFF" width="64px" height="32px" title="下载" color="#666666" border="1px solid #E5E5E5" @btnclick="download(GCTQDATA)"></Btn>
      </div>
      <div class="Print">
        <Btn btnType="btn" backgroundColor="#E71D43" width="64px" height="32px" title="打印" color="#FFFFFF" border="1px solid #E5E5E5" @btnclick="Print(GCTQDATA)"></Btn>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from '../../../../../../../../components/common-btn.vue'
import printAll from '../../../../../../../../common/Print'
export default {
  components: { Btn },
  props: {
    GCTQDATA: {
      type: Object
    }
  },
  data() {
    return {
      GCTQList: null,
      printObj: {
        id: "CertificateAuthorization", //打印页面的id
        popTitle: '', //打印的标题
        preview: false,
        //打印成功后的回调
        endCallback() {

        },
        beforeOpenCallback(vue) {
          console.log('打开之前')
        },
        closeCallback(vue) {
          console.log('关闭了打印工具', this.btn, vue)
        }
      }
    }
  },
  created() { },
  mounted() {
  },
  activated() { },
  updated() { },
  methods: {
    leftClick() {
      this.$emit('leftClick')
    },
    download(GCTQDATA) {
      this.$emit('download', GCTQDATA)
    },
    Print(GCTQDATA) {
      this.$emit('Print', GCTQDATA)
    }
  },
  computed: {},
  watch: {
    GCTQDATA: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.GCTQList = newVal
        }
      },
      deep: true,
      immediate: true
    }
  },
}
</script>
<style scoped lang='less'>
.Print {
  display: inline-block;
  margin-left: -10px;
}
.download {
  display: inline-block;
  margin-left: 750px;
  margin-top: 20px;
}
.fontRed {
  color: #e71d43;
}
.left {
  width: 48px;
  height: 48px;
  position: relative;
  left: 856px;
  top: 452px;
  cursor: pointer;
}
.line {
  width: 805px;
  height: 1px;
  background-color: #333333;
  margin-left: 0px;
}
.CertificateAuthorization {
  width: 100%;
  height: 100%;

  .context {
    width: 800px;
    // height: 916px;
    background: #ffffff;
    box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.10000000149011612);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    margin: 0 auto;
    position: relative;
    padding: 0px 20px 0 20px;

    .rightTop {
      margin-top: -80px;
      float: right;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }
    .rightTopEnglish {
      margin-top: -50px;
      float: right;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
    }

    .rightTopCode {
      margin-top: 0px;
      float: right;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
    }

    .rightTopTitle {
      position: absolute;
      top: 162px;
      left: 340px;
      font-size: 24px;
      font-weight: normal;
      color: #333333;
    }
    .contextTop1 {
      width: 815px;
      height: 112px;
      position: absolute;
      top: 220px;
      left: 24px;
      font-size: 14px;
      font-weight: normal;
      margin-left: -10px;
      color: #333333;
      text-indent: 2em;
      line-height: 25px;


      .contextListText-p{
        font-weight: bold;
      }
    }

    .contextTop2 {
      position: relative;
      top: 232px;
      left: 54px;
      font-size: 14px;
      margin-left: -10px;
      font-weight: normal;
      color: #333333;
      line-height: 25px;

      .hospital {
        height: 100%;
        width: 760px;
        margin-top: 10px;
        font-weight: bold;
      }
    }
    .contextTop3 {
      width: 800px;
      // height: 112px;
      position: relative;
      top: 250px;
      left: 24px;
      margin-left: -10px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      text-indent: 2em;
      text-indent: 2em;
      line-height: 25px;
    }
    .contextTop4 {
      position: relative;
      top: 280px;
      left: 29px;
      margin-left: -10px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      text-indent: 2em;
    }
    .contextTop5 {
      width: 800px;
      position: relative;
      top: 310px;
      left: 27px;
      margin-left: -10px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      text-indent: 2em;
      line-height: 25px;
    }

    .contextTop6 {
      position: relative;
      top: 350px;
      left: 611px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
    }
    .contextTop7 {
      position: relative;
      top: 370px;
      left: 675px;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
    }
    .contextTop8 {
      position: relative;
      margin-top: 450px;
      font-size: 10px;
      font-weight: normal;
      color: #333333;
      line-height: 20px;

      .Top {
        text-align: center;
      }

      .Centers {
        text-align: center;
      }
      .Bottom {
        text-align: center;
      }
    }
  }
}
</style>